module.exports = __webpack_public_path__ + "static/media/promulgation-landing-picture-book.47fdda47.png";